import getMetricsData from '@api/metricContainer';
import { get } from 'lodash';
import instance from '@api/axiosInstance';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { formatTimeseriesData } from '@src/components/metrics-panel-hz/utils/format';
import { createQuery } from '@src/components/widget-panel/utils/query';
import useQueryParams from '@src/components/widget-panel/hooks/useQueryParams';
import useWidgetQuery from '@src/components/widget-panel/hooks/useWidgetQuery';

function useFetchPercentiles({ wid, metrics = [] }) {
  const { interval, filter, _rKey, allowedMetrics, liveMode } = useQueryParams();

  const filteredMetrics = metrics.filter(
    (metric) =>
      metric in allowedMetrics ||
      getInvertedPercentageMetricByKey({ metricKey: metric }) in allowedMetrics,
  );
  const allowedMetricList = [...new Set([...filteredMetrics])];

  const options = {};

  const payload = createQuery(
    allowedMetricList,
    `${interval.from}/${interval.to}`,
    interval.granularity,
    filter,
    options,
  );

  return useWidgetQuery({
    wid,
    queryKey: ['widget', 'percentile', payload.queries, _rKey],
    queryFn: () =>
      getMetricsData(payload, {}, instance).then((response) => {
        const { data, totals, annotations } = get(response, ['data', '0'], {
          totals: {},
          data: [],
          annotations: [],
        });
        const formattedData = formatTimeseriesData({
          metrics: allowedMetricList,
          data,
          interval,
          annotations,
        });
        return { data: formattedData, totals };
      }),
    options: {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!metrics.length && !liveMode,
      staleTime: 5 * 60 * 1000, // 5m
    },
  });
}

export default useFetchPercentiles;
